import React, { useEffect, useState } from 'react';
import { Row, Col, FormInput } from '@snsw/react-component-library';
import { isEmpty, isNumeric, validateExt } from 'shared/utils/Validation';
import styles from '../PlantItemDetails.module.scss';
import { PlantItemDetailsPage } from 'plantItemNew/constants/plantItemDetailsPage';

export const BuildingMaintenanceUnitDetails = React.forwardRef((props, ref) => {
  const { value = {}, onChange = () => {}, onErrorChange = () => {} } = props;
  const { safeWorkingLoad: savedDesignerSafeWorkingLoad = '', maxWorkingHeight: savedMaxWorkingHeight = '' } = value;
  const [safeWorkingLoad, setSafeWorkingLoad] = useState(savedDesignerSafeWorkingLoad);
  const [maxWorkingHeight, setMaxWorkingHeight] = useState(savedMaxWorkingHeight);

  const [showErrors, setShowErrors] = useState(false);
  const [errors, setErrors] = useState({});
  const [errorSummary, setErrorSummary] = useState([]);

  const validators = [
    {
      fieldName: 'safeWorkingLoad',
      fieldValue: safeWorkingLoad,
      isValid: isNumeric,
      errorMessage: (v) => (isEmpty(v) ? 'Please enter details' : 'Please enter only numeric value'),
    },
    {
      fieldName: 'maxWorkingHeight',
      fieldValue: maxWorkingHeight,
      isValid: isNumeric,
      errorMessage: (v) => (isEmpty(v) ? 'Please enter details' : 'Please enter only numeric value'),
    },
  ];

  if (ref) {
    ref.current = {
      validate: () => {
        let isCurrentComponentValid = validateExt(validators, setErrors, setErrorSummary);

        setShowErrors(!isCurrentComponentValid);

        return isCurrentComponentValid;
      },
    };
  }

  useEffect(() => {
    let details = {
      safeWorkingLoad,
      maxWorkingHeight,
    };
    onChange(details);

    if (showErrors) validateExt(validators, setErrors, setErrorSummary);
  }, [safeWorkingLoad, maxWorkingHeight]);

  useEffect(() => {
    onErrorChange(errorSummary);
  }, [errorSummary]);

  return (
    <>
      <Row style={{ marginTop: 20 }}>
        <Col span={4}>
          <FormInput
            id="safeWorkingLoad"
            label={PlantItemDetailsPage.relatedDetails.buildingMaintenanceUnit.safeWorkingLoadLabel}
            suffix="kg"
            onChange={(e, { value }) => setSafeWorkingLoad(value)}
            value={safeWorkingLoad}
            errorMessage={errors?.safeWorkingLoad?.errorMessage}
            hasError={showErrors && errors?.safeWorkingLoad?.invalid}
            className={styles.inputWithSuffix}
          />
          <FormInput
            id="maxWorkingHeight"
            label={PlantItemDetailsPage.relatedDetails.buildingMaintenanceUnit.maxWorkingHeightLabel}
            suffix="m"
            onChange={(e, { value }) => setMaxWorkingHeight(value)}
            value={maxWorkingHeight}
            errorMessage={errors?.maxWorkingHeight?.errorMessage}
            hasError={showErrors && errors?.maxWorkingHeight?.invalid}
            className={styles.inputWithSuffix}
          />
        </Col>
      </Row>
    </>
  );
});

BuildingMaintenanceUnitDetails.displayName = 'BuildingMaintenanceUnitDetails';
